const APP_INFO = {
  ENVIRONMENT: "production",
  BASE_URL: "https://sandbox.ipg.class.id",
  VERSION: "Tue Jan 4 01:39:07 UTC 2022"
}

export default APP_INFO
